import validate from "/mnt/cache/teamcity-agent/work/c5c1aadee301441a/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/mnt/cache/teamcity-agent/work/c5c1aadee301441a/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "validate-city-route": () => import("/mnt/cache/teamcity-agent/work/c5c1aadee301441a/src/middleware/validateCityRoute.ts")
}